import React from 'react'
import { Form } from 'react-bootstrap'
import useItems from '../../../hooks/use-facilitators'
import useCurrentUser from '../../../hooks/use-current-user'
import { find } from 'lodash'

const LabelItem = ({ value = '', onChange =() => {} }) => {
    const [ items ] = useItems()
    const { isBusy, isFacilitator, isAdmin, id } = useCurrentUser()

    React.useEffect(() => {
        if (!isBusy && isFacilitator && !isAdmin && value !== id) {
            onChange(id)
        }
    }, [isBusy, value, onChange, isFacilitator, isAdmin, id])

    if (!items || isBusy) {
        return null
    }

    const users = isFacilitator && !isAdmin ? [find(items, { id })] : items

    return (
        <Form.Control as='select' value={value} onChange={e => onChange(e.target.value)} placeholder='test'>
            <option value=''></option>
            {users.map((item, k) => (<option value={item.id} key={k}>{item.name}</option>))}
        </Form.Control>
    )
}

export default LabelItem